import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute } from '@nuxtjs/composition-api'
import type { UserInputType, AccountType } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    account: null
  },
  setup(__props: any) {

const props = __props as {
  account: AccountType
};



const route = useRoute()

const questionnaireId = computed(() => Number(route.params.questionnaire))

const questionnaire = computed(() =>
  props.account?.euTaxonomyQuestionnaire?.id === questionnaireId.value
    ? props.account?.euTaxonomyQuestionnaire
    : null,
)

const questionnaireAssignment = computed(
  () => questionnaire.value?.questionnaireAssignment,
)

const sectionId = computed(() => Number(route.params.section))

const section = computed(() =>
  questionnaire.value?.questionnaireTemplate?.sections?.find(
    (e) => e.id === sectionId.value,
  ),
)

const userInputMapping = computed(() => {
  if (!questionnaireAssignment.value) return {}
  return Object.assign(
    {},
    ...questionnaireAssignment.value.userInputs.map((x: UserInputType) => ({
      [x.question.id as number]: x,
    })),
  )
})

return { __sfc: true,props, route, questionnaireId, questionnaire, questionnaireAssignment, sectionId, section, userInputMapping }
}

})